import { Area, VacancyArea, Store, StoreContract } from "throne-api";
import { FacilityVacancy } from "vacancy";

export interface RootState {
    store: Store | undefined;
    storeContract: StoreContract | undefined;
    areaList: Area[];
    vacancyAreaList: VacancyArea[];
    facilityVacancyList: FacilityVacancy[];
}

export const state: RootState = {
    store: undefined,
    storeContract: undefined,
    areaList: [],
    vacancyAreaList: [],
    facilityVacancyList: [],
};
